import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import useTheme from '../utils/use-theme';
import Layout from '../components/Layout';
import SEO from '../components/Seo';
import PageBuilder from '../components/PageBuilder';
import HeroBannerText from '../components/Banners/HeroBannerText';
import ParagraphContentSection from '../components/ParagraphContentSection';

const pageTemplate = {
  // eslint-disable-next-line react/prop-types
  'hero-banner-text': ({ data, themes }) => {
    return (
      <HeroStyles themes={themes}>
        <HeroBannerText data={data} themes={themes} />
      </HeroStyles>
    );
  },
  'paragraph-content': ParagraphContentSection,
};

const HeroStyles = styled.div`
  background-color: ${themeGet('colors.body-bg')};
`;

const PageStyles = styled.div`
  background-color: ${themeGet('colors.grey')};
`;

const TermsConditionsPage = ({ data }) => {
  const { themes, themesToggle } = useTheme();
  const { contentfulPage } = data;
  const {
    metaTitle,
    metaDescription,
    sections,
    optionalCustomPageHeader,
    customFooter,
    topNotificationBanner,
  } = contentfulPage;

  return (
    <Layout
      header={optionalCustomPageHeader}
      topNotificationBanner={topNotificationBanner}
      footer={customFooter}
      themes={themes}
      themesToggle={themesToggle}
    >
      <SEO
        metaTitle={metaTitle}
        metaDescription={metaDescription.metaDescription}
      />

      <PageStyles themes={themes}>
        <PageBuilder
          sections={sections}
          template={pageTemplate}
          themes={themes}
        />
      </PageStyles>
    </Layout>
  );
};

TermsConditionsPage.propTypes = {
  data: PropTypes.shape().isRequired,
};

export const query = graphql`
  query TermsConditionsPage($locale: String = "en-CA") {
    contentfulPage(
      contentful_id: { eq: "72rT1PhoAF9m4zSmW1DWNh" }
      node_locale: { eq: $locale }
    ) {
      contentful_id
      internalName
      node_locale
      metaTitle
      ...NotificationBanner
      metaDescription {
        metaDescription
      }
      ...OptionalHeader
      ...OptionalFooter
      sections {
        ...HeroBannerText
        ...ParagraphSection
      }
    }
  }
`;

export default TermsConditionsPage;
